import { Box, Group, Image, Tooltip } from "@mantine/core"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { useState, useCallback } from "react"
import dynamic from "next/dynamic"

import { HeaderNavBarButton } from "@/components/generic/HeaderNavBar/components/HeaderNavButton"
import classes from "./HeaderNavBar.module.css"

const Confetti = dynamic(() => import("react-dom-confetti").then((mod) => ({ default: mod.default })), {
  ssr: false,
})

const HeaderButtonSubscribe = dynamic(() => import("@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonSubscribe/HeaderButtonSubscribe").then((mod) => ({ default: mod.HeaderButtonSubscribe })), {
  ssr: false,
})

const confettiConfig = {
  angle: 90,
  spread: 360,
  startVelocity: 40,
  elementCount: 70,
  dragFriction: 0.12,
  duration: 3000,
  stagger: 3,
  width: "10px",
  height: "10px",
  colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
}

const BASE_TEST_ID = "headernavbar-"

export function HeaderNavBar() {
  const [isConfetti, setIsConfetti] = useState(false)
  const pathname = usePathname()
  const isWelcomePage = pathname === "/welcome"

  const handleConfetti = useCallback(() => {
    setIsConfetti(true)
    setTimeout(() => setIsConfetti(false), 100)
  }, [])

  const versionInfo = `${process.env.NEXT_PUBLIC_VERSION}-${process.env.NEXT_PUBLIC_ENV}-${process.env.NEXT_PUBLIC_BUILD_TIME}`

  const logoImage = (
    <Tooltip label={versionInfo} position="bottom">
      <Image data-testid={`${BASE_TEST_ID}logo`} alt="Ring.io" className={`h-6 ${isWelcomePage ? "cursor-pointer" : ""}`} src="/assets/ringio_complete_logo.png" onClick={isWelcomePage ? handleConfetti : undefined} />
    </Tooltip>
  )

  return (
    <Box component="header" px="md" data-testid={`${BASE_TEST_ID}container`} className={classes.header}>
      <Group justify="space-between" h="100%">
        <div className="flex items-center justify-start gap-6">
          <div style={{ position: "relative" }}>
            {isWelcomePage ? logoImage : <Link href="/">{logoImage}</Link>}
            <div style={{ position: "absolute", left: "50%", top: "50%" }}>
              <Confetti active={isConfetti} config={confettiConfig} />
            </div>
          </div>
        </div>

        <Group gap="xs" data-testid={`${BASE_TEST_ID}right-actions-container`}>
          {/* <HeaderNavBarButton type="ReferAFriend" /> */}
          {/* <HeaderNavBarButton type="Notifications" /> */}
          <HeaderButtonSubscribe />
          <HeaderNavBarButton type="Profile" />
        </Group>
      </Group>
    </Box>
  )
}
